import React from "react";

export default React.memo(function ArrowIcon() {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M24.4343 19.4343C24.7467 19.7467 24.7467 20.2533 24.4343 20.5657L19.9088 25.0912C19.5964 25.4036 19.0899 25.4036 18.7775 25.0912L14.252 20.5657C13.9396 20.2533 13.9396 19.7467 14.252 19.4343C14.5644 19.1219 15.0709 19.1219 15.3833 19.4343L19.3431 23.3941L23.3029 19.4343C23.6154 19.1219 24.1219 19.1219 24.4343 19.4343Z"
                fill="#7B869B"
            />
        </svg>
    );
});